<script>
import HelpButton from './HelpButton.vue'
import Icon from '@primer/octicons/build/svg/info-16.svg'

export default {
  name: 'InfoButton',
  components: {
    Icon,
  },
  extends: HelpButton,
}
</script>
